(ns net.kestec.mhda-pilgrimage.admin.popup.application-status-popup
  (:require ["@mui/material/Button" :default Button]
            ["@mui/material/Modal" :default Modal]
            ["@mui/material/Grid" :default Grid]
            ["@mui/material/FormLabel" :default FormLabel]
            ["@mui/material/Select" :default Select]
            ["@mui/material/MenuItem" :default MenuItem]
            ["@mui/icons-material/Cancel" :default CancelIcon]
            ["@mui/icons-material/Done" :default DoneIcon]

            [ajax.core :as ajax]
            [net.kestec.mhda-pilgrimage.db :as-alias db]
            [net.kestec.mhda-pilgrimage.admin.applications.applications-events :as-alias admin-applications-events]
            [net.kestec.mhda-pilgrimage.admin.applications.application-events :as-alias admin-application-events]
            [net.kestec.re-frame.event :as-alias event]
            ["react" :as react]
            [re-frame.core :as rf]
            [reagent.core :as r]))




(defn claim-status-form* [application]
  (let [applicationId (:id application)
        !mhda_type (r/atom (or (:mhda_type application) "PI"))
        !selected_division (r/atom (str (:selected_division application)))]
    ;(println "claim-status-form* " claim)

    [:div
     {:class "modal"
      :style {:min-width "600px"}}
     [:h4 "Antrag " (:shown_first_name application) " " (:shown_family_name application)]
     [:div
      ;[:pre "PRE "(pr-str application)]
      [:> Grid {:container  true
                :direction  "row"
                :justify    "center"
                :alignItems "flex-start"
                :spacing    2}

       ;[:> Grid {:item true :xs 12} (pr-str claim)]
       [:> Grid {:item true :xs 12}
        [:> FormLabel {:style {:fontSize "0.75rem"}} "Bereich ändern"
         [:> Select
          {:fullWidth    true
           :defaultValue (str (:selected_division application))
           :onChange     #(reset! !selected_division (.. % -target -value))
           :label        "Bereich"}

          [:> MenuItem {:value "B"} "Burgenland"]
          [:> MenuItem {:value "OO"} "Oberösterreich"]
          [:> MenuItem {:value "Sb"} "Salzburg"]
          [:> MenuItem {:value "St"} "Steiermark/Kärnten"]
          [:> MenuItem {:value "T"} "Tirol/Vorarlberg"]
          [:> MenuItem {:value "W"} "Wien/Niederösterreich"]
          [:> MenuItem {:value "Bu"} "Bund/Einsatzleitung"]

          ]]]

       [:> Grid {:item true :xs 12}]

       [:> Grid {:item true :xs 12}
        [:> FormLabel {:style {:fontSize "0.75rem"}} "Typ ändern"
         [:> Select
          {:fullWidth    true
           :defaultValue (or (:mhda_type application) "PI")
           :onChange     #(reset! !mhda_type (.. % -target -value))
           :label        "Typ"}

          [:> MenuItem {:value "PA"} "PA Patient"]
          [:> MenuItem {:value "PI"} "PI Pilger"]
          [:> MenuItem {:value "HPI"} "HPI Hilfs-Pilger"]
          [:> MenuItem {:value "PE"} "PE Personal"]

          ]]]

       ]]
     [:br]
     [:br]

     [:> Button
      {:style     {:float "left"}
       :variant   "outlined"
       :startIcon (r/as-element [:> CancelIcon])
       :onClick   #(rf/dispatch [::admin-applications-events/set-status-popup-application nil])
       }
      "Abbrechen"]

     [:> Button
      {:style     {:float "right"}
       :variant   "contained"
       :startIcon (r/as-element [:> DoneIcon])
       :onClick   (fn []
                    (rf/dispatch [::admin-application-events/update-application applicationId {:selected_division @!selected_division :mhda_type @!mhda_type}])
                    (rf/dispatch [::admin-applications-events/set-status-popup-application nil]))
       }
      (or @(rf/subscribe [::db/get ::saveButton]) "ok")]
     ]

    ))

(defn application-status-popup []
  (when-let [application-id @(rf/subscribe [::db/get ::db/status-popup-application])]
    (let [application (first (filter #(= application-id (:id %)) @(rf/subscribe [::db/get ::admin-applications-events/admin-applications])))]
      [:> Modal {:aria-labelledby  "simple-modal-title"
                 :aria-describedby "simple-modal-description"
                 :style            {:display        "flex"
                                    :marginRight    "auto"
                                    :marginLeft     "auto"
                                    :alignItems     "center"
                                    :justifyContent "center"}
                 :open             (if (nil? application-id) false true)

                 }
       [:f> claim-status-form* application]]
      )))